import { useQuery } from '@apollo/client';
import trimDetail from '../../graphql/queries/trimDetail';
import { GetTrimDetail, GetTrimDetailVariables } from '../../graphql/queries/__generated__/GetTrimDetail';
import useCollectedFilters from '../useCollectedFilters';
import useErrorHandler from '../../../gqlCommon/hooks/useErrorHandler';

const useTrimDetail = () => {
  const { filters } = useCollectedFilters();

  const { data, loading, error } = useQuery<GetTrimDetail, GetTrimDetailVariables>(trimDetail.GET_TRIM_DETAIL, {
    fetchPolicy: 'network-only',
    variables: {
      ...filters,
    },
  });

  useErrorHandler(error);

  return { data, loading, error };
};

export default useTrimDetail;
